//特定のクラスすべて取得
var modal_btn = document.querySelectorAll(".modal__btn");
var close_btn = document.querySelectorAll(".modal__cntInnerClose");
var close_bg = document.querySelectorAll(".modal__cntBg");

var home = document.querySelectorAll(".home");

//それぞれのクラスにイベントをつける
modal_btn.forEach(function (target) {
  target.addEventListener("click", function () {
    var data = target.dataset.target;
    var modal = document.getElementById(data);
    toggleClass(modal);
  });
});

close_btn.forEach(function (target) {
  target.addEventListener("click", function () {
    var close = target.parentNode.parentNode;
    toggleClass(close);
  });
});

close_bg.forEach(function (target) {
  target.addEventListener("click", function () {
    var close = target.parentNode;
    toggleClass(close);
  });
});

function toggleClass(klass) {
  klass.classList.toggle("is_show");

  //modal出てるときは.homeをスクロールさせない
  if (klass.classList.contains("is_show")) {
    home.item(0).style.overflow = "hidden";
  } else {
    home.item(0).style.overflow = "auto";
  }
}
